module.exports = __webpack_public_path__ + "media/images/shared/icon_weibo-6b3f7bc0df6db5cb6713a55aa484ee74.png";